import { groupBy, isEmpty, map } from 'lodash'
import type { Translation } from 'types'
import type { State } from './reducer'

export const updateCurrentTranslation = (
  state: State,
  update: Partial<Translation>
) => {
  const { data: { translations = [] } = {}, selectedLanguage } = state

  return translations.map<Translation>(t =>
    t.languageCode === selectedLanguage ? { ...t, ...update } : t)
}

export const isRelevantTranslation = (
  state: State,
  action: {
    payload: {
      reportId: string;
      languageCode: string;
    };
  }
) => {
  const { data: { id: currentReportId, translations } = {}, selectedLanguage } = state
  const { reportId, languageCode } = action.payload

  return (
    !!currentReportId &&
    !!translations &&
    reportId === currentReportId &&
    languageCode === selectedLanguage
  )
}

export const mergeTranslations = (
  firstArray: Array<Translation> = [],
  secondArray: Array<Translation> = [],
) => {
  if (isEmpty(firstArray)) return secondArray
  if (isEmpty(secondArray)) return firstArray

  const grouped = groupBy([...firstArray, ...secondArray], 'languageCode')
  return map(grouped, (group) => ({ ...group[group.length - 1] }))
}
